export default {
	computed: {
		errors () {
			if (this.$page.props.hasOwnProperty('errors')) {
				return this.$page.props.errors
			}

			return {}
		}
	},
	methods: {
		hasError (fieldName) {
			return this.errors.hasOwnProperty(fieldName)
		},
		errorMessages (fieldName) {
			if (this.hasError(fieldName)) {
				if (typeof this.errors[fieldName] === 'object') {
					return this.errors[fieldName]
				} else {
					return [this.errors[fieldName]]
				}
			}

			return []
		}
	}
}
